import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  useGetAllUserRoleQuery,
  useGetUserAccessQuery,
  useUpdateUserRoleMutation,
} from "AppQuries/user/user-role";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import Datatable from "core/pagination/datatable";
import { loggedInUser } from "core/redux/slice/authSlice";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { message } from "antd";
import { all_routes } from "Router/all_routes";
import { Checkbox } from "antd";
import { sub } from "date-fns";
import { Save } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { setPermissions } from "core/redux/slice/userPermissionSlice";
import { decrypt } from "core/Operations/cryptHelper";
const UserRoleManagement = () => {
  const userData = useSelector(loggedInUser);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { code } = useParams();
  const { handleSubmit } = useForm();
  const navigate = useNavigate();
  // Fetch user roles
  // const {
  //   data: userRoles,
  //   isLoading,
  //   isError,
  //   error,
  // } = useGetAllUserRoleQuery({
  //   companyCode: userData?.companyCode,
  // });

  const { data, isLoading, isError, error } = useGetUserAccessQuery({
    companyCode: userData?.companyCode,
    UserGroupCode: code,
  });

  const { mutate: updateUserRoles } = useUpdateUserRoleMutation();

  const [menuPermissions, setMenuPermissions] = useState({});

  // Helper to update permissions for a specific sub-menu or menu
  const updatePermission = (menu, subMenuName, type, value) => {
    setMenuPermissions((prevPermissions) => ({
      ...prevPermissions,
      [menu]: {
        ...prevPermissions[menu],
        subMenus: {
          ...(prevPermissions[menu]?.subMenus || {}),
          [subMenuName]: {
            ...(prevPermissions[menu]?.subMenus?.[subMenuName] || {}),
            [type]: value,
          },
        },
      },
    }));
  };

  // Update all permissions for a sub-menu
  const handleSelectAll = (menu, subMenuName, value) => {
    const allPermissions = ["view", "create", "edit", "delete", "allowAll"];
    setMenuPermissions((prevPermissions) => ({
      ...prevPermissions,
      [menu]: {
        ...prevPermissions[menu],
        subMenus: {
          ...(prevPermissions[menu]?.subMenus || {}),
          [subMenuName]: allPermissions.reduce(
            (acc, perm) => ({ ...acc, [perm]: value }),
            {}
          ),
        },
      },
    }));
  };

  const transformAccessData = (menuData, user = "") => {
    const permissions = menuData?.map((sub) =>
      sub.subMenu?.map((sm) => {
        return {
          userGroupCode: sub.userGroupCode || "",
          user: user,
          menuName: menuData.menuName || "",
          formCode: sub.formCode || "",
          subMenu: sub.subMenu || "",
          companyCode: sub.companyCode,
          isActive: true,
          haveView: sm.haveView ?? false,
          haveAdd: sm.haveAdd ?? false,
          haveEdit: sm.haveEdit ?? false,
          haveDelete: sm.haveDelete ?? false,
        };
      })
    );

    return permissions;
    //   //   sub
    //   //   {
    //   //   userGroupCode: userGroupCode || "string",
    //   //   user,
    //   //   formCode: formCode || "string",
    //   //   subMenu: sub.subMenu || "string",
    //   //   companyCode: sub.companyCode ?? companyCode ?? 0,
    //   //   isActive: isActive ?? true,
    //   //   haveView: sub.haveView ?? false,
    //   //   haveAdd: sub.haveAdd ?? false,
    //   //   haveEdit: sub.haveEdit ?? false,
    //   //   haveDelete: sub.haveDelete ?? false,
    //   // }));
    // );
  };

  // Submit the permissions
  const onSubmit = () => {
    const userGroupCode = code;
    const companyCode = userData?.companyCode;
    const isActive = true;

    const formattedData = userAccess?.flatMap((menu) =>
      menu.subMenu.map((subMenu) => ({
        userGroupCode: menu.userGroupCode || "",
        user: userData?.userName || "",
        menuName: menu.menuName || "", // For maintain the access format form the login
        formCode: menu.formCode || "", // Use parent menu formCode
        subMenu: subMenu.subMenu || "",
        companyCode: subMenu.companyCode ?? companyCode ?? 0,
        isActive: true,
        haveView: subMenu.haveView ?? false,
        haveAdd: subMenu.haveAdd ?? false,
        haveEdit: subMenu.haveEdit ?? false,
        haveDelete: subMenu.haveDelete ?? false,
      }))
    );

    dispatch(
      setPermissions({
        permissions: formattedData,
      })
    );

    updateUserRoles(formattedData, {
      onSuccess: (data) => {
        if (data?.[0]?.response === true) {
          message.success("User Role Permission Updated Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.user_group}${all_routes.user_group_list}`);
          }, 1000);
        } else {
          message.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        message.warning(error.message || "Something went wrong.");
      },
    });
  };

  const [userAccess, setUserAccess] = useState([]);

  // Load API data on mount
  useEffect(() => {
    if (!data) return;
    setUserAccess(data);
  }, [data]);

  const renderCheckbox = (menu, subMenuName, type, checked, onChange) => (
    <label className="checkboxs">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="checkmarks" />
    </label>
  );

  const columns = [
    {
      title: "Module",
      dataIndex: "menu",
      render: (text, record) => (
        <>{`${record.menuName} ${
          record.subMenu !== null ? `/ ${record.subMenu}` : ""
        }`}</>
      ),
    },
    {
      title: "Allow All",
      render: (_, record) =>
        renderCheckbox(
          record.menuName,
          record.subMenu,
          "allowAll",
          menuPermissions[record.menu]?.subMenus?.[record.subMenu]?.allowAll ||
            false,
          (checked) =>
            handleSelectAll(record.menu, record.subMenu || "", checked)
        ),
    },
    ...["View", "Create", "Edit", "Delete"].map((action) => ({
      title: action,
      render: (_, record) =>
        renderCheckbox(
          record.menu,
          record.subMenu,
          action.toLowerCase(),
          menuPermissions[record.menu]?.subMenus?.[record.subMenu]?.[
            action.toLowerCase()
          ] || false,
          (checked) =>
            updatePermission(
              record.menu,
              record.subMenu || "",
              action.toLowerCase(),
              checked
            )
        ),
    })),
  ];

  const togglePermission = (menuName, subMenuName, key) => {
    setUserAccess((prev) =>
      prev.map((menu) =>
        menu.menuName === menuName
          ? {
              ...menu,
              subMenu: menu.subMenu.map((sub) =>
                sub.subMenu === subMenuName ? { ...sub, [key]: !sub[key] } : sub
              ),
            }
          : menu
      )
    );
  };

  const toggleAll = (menuName, subMenuName) => {
    setUserAccess((prev) =>
      prev.map((menu) =>
        menu.menuName === menuName
          ? {
              ...menu,
              subMenu: menu.subMenu.map((sub) => {
                if (sub.subMenu === subMenuName) {
                  const isAllChecked =
                    sub.haveView &&
                    sub.haveAdd &&
                    sub.haveEdit &&
                    sub.haveDelete;

                  return {
                    ...sub,
                    haveView: !isAllChecked,
                    haveAdd: !isAllChecked,
                    haveEdit: !isAllChecked,
                    haveDelete: !isAllChecked,
                  };
                }
                return sub;
              }),
            }
          : menu
      )
    );
  };

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>User Permission</h4>
                  <h6>Manage your user permissions</h6>
                </div>
              </div>

              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.user_group}${all_routes.user_group_list}`}
                    className="btn btn-secondary"
                  >
                    Back
                  </Link>
                </OverlayTrigger>
              </div>
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Save User Permission</Tooltip>
                  }
                >
                  <button type="submit" className="btn btn-added">
                    <Save className="me-2" />
                    Save
                  </button>
                </OverlayTrigger>
              </div>
            </div>

            <div className="card table-list-card border-0 mt-3">
              <div className="card-header">
                <h4 className="header-title">{decrypt(searchParams.get("userGroupName"))}</h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped custom-table mb-0">
                    <thead>
                      <tr>
                        <th>Module</th>
                        <th>Allow All</th>
                        <th>View</th>
                        <th>Create</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>

                    <tbody>
                      {userAccess.map((menu) =>
                        menu.subMenu.map((sub) => (
                          <tr key={sub.subMenu}>
                            <td>
                              {menu.menuName} / {sub.subMenu}
                            </td>
                            <td>
                              <Checkbox
                                checked={
                                  sub.haveView &&
                                  sub.haveAdd &&
                                  sub.haveEdit &&
                                  sub.haveDelete
                                }
                                // onCheckedChange={() =>
                                //   toggleAll(menu.menuName, sub.subMenu)
                                // }
                                onClick={() =>
                                  toggleAll(menu.menuName, sub.subMenu)
                                }
                              />
                            </td>
                            {[
                              "haveView",
                              "haveAdd",
                              "haveEdit",
                              "haveDelete",
                            ].map((action) => (
                              <td key={action}>
                                <Checkbox
                                  checked={sub[action]}
                                  onClick={() =>
                                    togglePermission(
                                      menu.menuName,
                                      sub.subMenu,
                                      action
                                    )
                                  }
                                />
                              </td>
                            ))}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  {/* Uncomment the following line if you want to use Datatable component */}
                  {/* <Datatable
                    columns={columns}
                    dataSource={userAccess}
                    pagination={false}
                  /> */}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserRoleManagement;
